/* Radiobuttons */
$(document).on('change', '.__radio input', function () {
    if ($(this).is(':checked')) {
        $(this)
            .closest('.__radio')
            .find('.input_wrap > label')
            .removeClass('__checked');
        $(this)
            .parent()
            .addClass('__checked');
    }
});
$('.__radio input:checked')
    .parent()
    .addClass('__checked');

/* Checkboxes */
$(document).on('change', '.__checkbox input', function () {
    if ($(this).is(':checked')) {
        $(this)
            .parent()
            .addClass('__checked');
    } else {
        $(this)
            .parent()
            .removeClass('__checked');
    }
});
$('.__checkbox input:checked')
    .parent()
    .addClass('__checked');

/* Toggle */
$(document).on('change', '.__toggle input', function () {
    if ($(this).is(':checked')) {
        $(this)
            .closest('.__toggle')
            .find('.input_wrap > label')
            .removeClass('__checked');
        $(this)
            .parent()
            .addClass('__checked');
    }
});
$('.__toggle input:checked')
    .parent()
    .addClass('__checked');

/* Quantity toggle */
$('.plus').click(function (e) {
    console.log('click plus');
    let $input = $(this).prev('input.qty');
    let val = parseInt($input.val());
    $input.val(val + 1).change();
});

$('.minus').click(function (e) {
    console.log('click minus');
    let $input = $(this).next('input.qty');
    var val = parseInt($input.val());
    if (val > 0) {
        $input.val(val - 1).change();
    }
});

/* Focus state */
$(document).ready(function () {
    $('.field_wrap.__radio input').focus(function () {
        $(this)
            .closest('label')
            .addClass('__focused');
    }).blur(function () {
        $(this)
            .closest('label')
            .removeClass('__focused');
    });
    $('.field_wrap.__checkbox input').focus(function () {
        $(this)
            .closest('label')
            .addClass('__focused');
    }).blur(function () {
        $(this)
            .closest('label')
            .removeClass('__focused');
    });
    $('.field_wrap.__toggle input').focus(function () {
        $(this)
            .closest('label')
            .addClass('__focused');
    }).blur(function () {
        $(this)
            .closest('label')
            .removeClass('__focused');
    });
});

/* Reset checkboxes and dropdown selection */
$('.__reset').click(function () {
    $('.__radio label').removeClass('__checked');
    $('.__checkbox label').removeClass('__checked');
    $('.__toggle label').removeClass('__checked');
    $('.__select .select2-selection__rendered').empty().addClass('__cleared');
    $('.__selectwithimages .select2-selection__rendered').empty().addClass('__cleared');
})

$(function () {

    $('.helper_wrap-icon').click(function (e) {
        var helperParent = $(this).parent('.helper_wrap');
        var fieldParent = helperParent.parent('.field_wrap');

        e.stopPropagation()
        if ($(this).hasClass('__active')) {
            $('.helper_wrap-icon').removeClass('__active');
            $('.helper_wrap-text').removeClass('__active');
        }

        else {
            $(this).addClass('__active');
            $(this).next('.helper_wrap-text').addClass('__active');
            fieldParent.siblings().find('.helper_wrap-text').removeClass('__active'); // close other active tooltips
            fieldParent.siblings().find('.helper_wrap-icon').removeClass('__active'); // reset other icons
        }
    })

    $(document).on("click", function (e) {
        if ($(e.target).is(".helper_wrap-icon") === false) {
            $('.helper_wrap-icon').removeClass('__active');
            $('.helper_wrap-text').removeClass('__active');
        }
    });

    $('.helperWrapClose').click(function () {
        $('.helper_wrap-icon').removeClass('__active');
        $('.helper_wrap-text').removeClass('__active');
    });
});

// Default select with no search
$('.__select select').each(function () {
    $(this).select2({
        containerCssClass: 'select2-css',
        minimumResultsForSearch: Infinity,
    })
});

$('#showFirst').click(function () {
    console.log('button one clicked')
    $('.form-additional').addClass('__active');
    $('.form-additional .__first').addClass('__active');

})

$('#showSecond').click(function () {
    $('.form-additional .__second').addClass('__active');
})
